var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4974 14.5834C20.7191 14.5834 23.3307 11.9717 23.3307 8.75002C23.3307 5.52836 20.7191 2.91669 17.4974 2.91669C14.2757 2.91669 11.6641 5.52836 11.6641 8.75002C11.6641 11.9717 14.2757 14.5834 17.4974 14.5834Z",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1654 25.5209C29.1654 29.1448 29.1654 32.0834 17.4987 32.0834C5.83203 32.0834 5.83203 29.1448 5.83203 25.5209C5.83203 21.8969 11.0558 18.9584 17.4987 18.9584C23.9416 18.9584 29.1654 21.8969 29.1654 25.5209Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserImg);
export default __webpack_public_path__ + "static/media/user_img.094204b33c0e47ae3911831e4c5ab4fc.svg";
export { ForwardRef as ReactComponent };